/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel' <vishal@wakencode.com>, May 2020
 *
 *****************************************************************************/

import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { constant } from "./../../../shared/constants/constants";

const DeleteConfirmDialog = (props) => {
  // called when user click on delete button
  // close dialog box and delete the geometry
  const deleteHandler = () => {
    props.delete();
    props.setDeleteDialogVisible(false);
  };
  // close dialog box
  const close = () => {
    props.setDeleteDialogVisible(false);
  };
  return (
    <div>
      <Dialog open={props.isVisible} aria-labelledby="delete-confirmation">
        <DialogContent>
          <DialogContentText>
            {constant.GEOFENCE_DELETE_CONFIRMATION_MSG}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={deleteHandler} color="primary">
            {constant.DELETE}
          </Button>
          <Button onClick={close} color="primary">
            {constant.CANCEL}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

// used to avoid unnecessary renders
const areEqual = (prevProps, nextProps) => {
  return !(prevProps.isVisible !== nextProps.isVisible);
};
export default React.memo(DeleteConfirmDialog, areEqual);
